// hyuh 크로스프로모 — 링크 디스패처 + 노출 게이트 + 소스 태그 트래킹.
// 노출: 결과 상세 하단 · 설정 (입력 화면 제외 — 몰입 보호). AdMob 슬롯과 분리(자체 앱).
import { isNative, isToss } from "./native";
import { track } from "./analytics";

const HYUH = {
  web: "https://hyuh.app",
  android: "https://play.google.com/store/apps/details?id=com.hyuh.app",
  // hyuh iOS 라이브(2026-06-24 승인) — "Hyuh: The Moon Writes Back" id6782901748.
  ios: { url: "https://apps.apple.com/app/id6782901748", enabled: true },
};

// bwek iOS(네이티브)는 심사 통과 후 켠다 — 그 전엔 bwek iOS 앱에서 배너 숨김. (웹·Android는 지금 노출.)
const SHOW_ON_BWEK_IOS = false;

function isAppleUA(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || "");
}
function isAndroidUA(): boolean {
  return /Android/i.test(navigator.userAgent || "");
}

/** 노출 여부. 토스(자사앱 유도 금지)·미승인 bwek iOS 네이티브에선 숨김. */
export function hyuhPromoVisible(): boolean {
  if (isToss()) return false; // 토스 정책: 외부 앱 설치 유도 금지
  if (isNative() && isAppleUA() && !SHOW_ON_BWEK_IOS) return false; // bwek iOS 심사 후 켬
  return true;
}

/** 이동할 hyuh URL — '기기' 기준(웹·네이티브 무관): 아이폰→App Store / 안드로이드→Play / 데스크톱→hyuh 웹.
 *  (모바일 웹 사용자도 스토어로 보내 설치 전환↑.) iOS는 미라이브면 hyuh 웹으로 폴백. */
export function hyuhUrl(): string {
  if (isAppleUA()) return HYUH.ios.enabled ? HYUH.ios.url : HYUH.web;
  if (isAndroidUA()) return HYUH.android;
  return HYUH.web; // 데스크톱 등
}

export type PromoSource = "bwek_result" | "bwek_settings";

/** 클릭: 소스 태그로 전환 출처 측정 + 외부로 열기. */
export function openHyuh(source: PromoSource): void {
  try {
    track("crosspromo_click", { source, target: "hyuh" });
  } catch {
    /* 분석 실패 무시 */
  }
  window.open(hyuhUrl(), "_blank", "noopener");
}
